import Constants from '../config/const';
import { loadHanging, saveHanging, saveHangingImage } from '../config/api';

export const load = () => (dispatch, getState) => {
  const { canvas: { wallId } } = getState();
  dispatch({ type: Constants.hangings.load });
  loadHanging(wallId).then(({ hangingMarks }) => {
    dispatch({
      type: Constants.hangings.loaded,
      hangingMarks
    });
  });
};

export const update = (first, second, kind, isAdd) => ({
  type: Constants.hangings.update, first, second, kind, isAdd
});

export const reset = () => ({
  type: Constants.hangings.reset
});

export const save = (image) => (dispatch, getState) => {
  const { hangings: { hangingMarks }, canvas: { wallId } } = getState();
  dispatch({ type: Constants.hangings.saving });
  saveHanging(wallId, hangingMarks).then(({ hangingMarks: newMarks }) => {
    saveHangingImage(wallId, image).then(() => {
      dispatch({ type: Constants.hangings.saved, hangingMarks: newMarks });
    });
  });
};
